import React from 'react';
import { m } from 'framer-motion';
import { FlameIcon } from 'lucide-react';
import { PrimaryButton } from '../ui/PrimaryButton';
import { StarRating } from '../ui/StarRating';
import { SectionTag } from '../ui/SectionTag';
import { scrollToId } from '../../utils/scroll';
export function Hero() {
  return <header className="relative overflow-hidden bg-bg-primary pb-10 pt-8 sm:pb-12 sm:pt-10" data-id="element-115" data-mp="hvz4dzzy5igi">
      <div className="pointer-events-none absolute -top-40 left-1/2 h-[420px] w-[720px] -translate-x-1/2 rounded-full bg-lime/10 blur-3xl" aria-hidden="true" data-id="element-116" data-mp="mutwxtnpuldt" />
      <div className="relative mx-auto flex max-w-4xl flex-col items-center px-4 text-center sm:px-6" data-id="element-117" data-mp="vmm0dkebou8w">
        <m.div initial={{
        opacity: 0,
        y: 12
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.5
      }} data-id="element-118" data-mp="10lyo07d0q5cj">
          <SectionTag icon="⚽" data-id="element-119" data-mp="15lbdkzv9xqit">Para entrenadores que quieren dejar de improvisar</SectionTag>
        </m.div>

        <m.h1 initial={{
        opacity: 0,
        y: 16
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.5,
        delay: 0.1
      }} className="mt-5 font-heading text-4xl font-bold uppercase leading-[1.08] tracking-tight text-white sm:text-5xl md:text-6xl" data-id="element-120" data-mp="1ako8m7wau3wh">
          Deja de perder horas planificando tus entrenamientos.
        </m.h1>

        {/* Plain img (no entrance animation): keeps paint instant once it downloads. */}
        <img src="https://cdn.magicpatterns.com/uploads/mfmCvTRZV6k4Vcdxb6hPSY/ChatGPT_Image_20_ago_2026__12_50_49__1_-removebg-preview.png" alt="MISTER PRO: La Pizarra del Entrenador — colección de 6 tomos y 5 bonos" width={640} height={620} loading="eager" fetchPriority="high" decoding="async" className="mt-8 w-full max-w-md sm:max-w-lg" data-id="element-121" data-mp="se0ys3wg6nrr" />

        <m.p initial={{
        opacity: 0,
        y: 12
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.5,
        delay: 0.18
      }} className="mt-6 max-w-2xl text-base leading-relaxed text-muted sm:text-lg" data-id="element-122" data-mp="1b5tptsryhywu">
          Organiza tus sesiones con MISTER PRO: 6 tomos digitales y 5 bonos con entrenamientos, ejercicios,
          diagramas, progresiones y correcciones para trabajar la técnica, la táctica y el juego colectivo
          de tu equipo.
        </m.p>

        <m.p initial={{
        opacity: 0,
        y: 12
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.5,
        delay: 0.22
      }} className="mt-4 max-w-2xl text-sm font-medium text-lime sm:text-base" data-id="element-123" data-mp="2vu5n1zfya56k">
          Más de 150 sesiones · Acceso digital inmediato
        </m.p>

        <m.div initial={{
        opacity: 0,
        y: 12
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.5,
        delay: 0.28
      }} className="mt-7 flex flex-col items-center" data-id="element-124" data-mp="27yjmwtm04bl1">
          <PrimaryButton onClick={() => scrollToId('oferta-base')} data-id="element-125" data-mp="66of4p2v8r83">Quiero organizar mis entrenamientos</PrimaryButton>
          <p className="mt-3 text-xs text-muted sm:text-sm" data-id="element-126" data-mp="b2lx0zts25mz">
            ⚡ Acceso inmediato · 📱 Formato digital · Úsalo desde el móvil, la tablet o la computadora
          </p>
        </m.div>

        <m.div initial={{
        opacity: 0
      }} animate={{
        opacity: 1
      }} transition={{
        duration: 0.5,
        delay: 0.34
      }} className="mt-6 flex flex-col items-center gap-2 text-sm text-muted sm:flex-row sm:gap-4" data-id="element-127" data-mp="1qm31iwo91ymx">
          <div className="flex items-center gap-2" data-id="element-128" data-mp="2ecgvwtub49ko">
            <StarRating data-id="element-129" data-mp="2efcwkpxjhcct" />
            <span className="font-medium text-white" data-id="element-130" data-mp="2acg5sbxui9xs">4,9/5</span>
            <span data-id="element-131" data-mp="2adzqqfug595w">· +500 reseñas verificadas</span>
          </div>
          <div className="hidden h-4 w-px bg-white/15 sm:block" aria-hidden="true" data-id="element-132" data-mp="2oad7fmr5p6jb" />
          <div className="flex items-center gap-1.5 text-lime" data-id="element-133" data-mp="2jdmqyybfw8xd">
            <FlameIcon size={16} className="fill-lime" data-id="element-134" data-mp="txnd53wvlvbe" />
            <span data-id="element-135" data-mp="ty6sccv565lq">42 entrenadores eligieron MISTER PRO hoy</span>
          </div>
        </m.div>
      </div>
    </header>;
}